import React from "react";

export default function PillCerrado() {
  return <div className="pill cerrado">Cerrado</div>;
}
